import type { MetricKey } from '../types/launch'

export const METRICS: Record<MetricKey, { label: string; unit: string; decimals: number }> = {
  ball_speed: { label: 'Ball speed', unit: 'mph', decimals: 1 },
  club_speed: { label: 'Club speed', unit: 'mph', decimals: 1 },
  smash_factor: { label: 'Smash factor', unit: '', decimals: 2 },
  launch_angle: { label: 'Launch angle', unit: '°', decimals: 1 },
  launch_direction: { label: 'Launch direction', unit: '°', decimals: 1 },
  spin_rate: { label: 'Spin rate', unit: 'rpm', decimals: 0 },
  spin_axis: { label: 'Spin axis', unit: '°', decimals: 1 },
  carry: { label: 'Carry', unit: 'yd', decimals: 1 },
  total: { label: 'Total', unit: 'yd', decimals: 1 },
  offline: { label: 'Offline', unit: 'yd', decimals: 1 },
  apex: { label: 'Apex', unit: 'yd', decimals: 1 },
  descent_angle: { label: 'Descent angle', unit: '°', decimals: 1 },
  attack_angle: { label: 'Attack angle', unit: '°', decimals: 1 },
  club_path: { label: 'Club path', unit: '°', decimals: 1 },
  face_angle: { label: 'Face angle', unit: '°', decimals: 1 },
  face_to_path: { label: 'Face to path', unit: '°', decimals: 1 },
  dynamic_loft: { label: 'Dynamic loft', unit: '°', decimals: 1 },
}

export function metricValue(key: MetricKey, value: number | null, signed = false): string {
  if (typeof value !== 'number' || !Number.isFinite(value)) return '—'
  const decimals = METRICS[key].decimals
  const number = value.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
  return signed && value > 0 ? `+${number}` : number
}

export function statText(key: MetricKey, mean: number | null, sd: number | null): string {
  return mean === null ? '—' : `${metricValue(key, mean)} ± ${metricValue(key, sd)}`
}

export function lateralSignDescription(verified: boolean): string {
  return verified
    ? 'Positive lateral values point right.'
    : 'Left/right is shown as exported by the monitor; the sign convention is not yet verified.'
}

export function sessionDate(value: string | null): string {
  if (!value) return 'Date not recorded'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return 'Date not recorded'
  return new Intl.DateTimeFormat('en-US', { dateStyle: 'medium', timeZone: 'UTC' }).format(date)
}
